import { throwError } from "rxjs";

export const GetNetworkErrorMessage = (error: any, defaultErrorMessage?: string) => {
    let errMessage = defaultErrorMessage || 'Une erreur est survenue lors de la requete au serveur';
    if (!!error) {
        if (!!error.error) {
            if (!!error.error.errors) {
                errMessage = Object.keys(error.error.errors).map(k => error.error.errors[k].join(' ')).join(' ');
            } else if (!!error.error.Message) {
                errMessage = error.error.Message;
            }
        } else if (!!error.message) {
            errMessage = error.message;
        }
    }
    return errMessage;
};

export const GetAsyncNetworkErrorMessage = async (error: any, defaultErrorMessage?: string) => {
    let errMessage = defaultErrorMessage || 'Une erreur est survenue lors de la requete au serveur';
    if (!!error) {
        if (!!error.error) {
            if (error.error instanceof Blob) {
                try {
                    const rawError = await error.error.text();
                    error.error = JSON.parse(rawError);
                } catch(e) {}
            }
            if (!!error.error.errors) {
                errMessage = Object.keys(error.error.errors).map(k => error.error.errors[k].join(' ')).join(' ');
            } else if (!!error.error.Message) {
                errMessage = error.error.Message;
            }
        } else if (!!error.message) {
            errMessage = error.message;
        }
    }
    return errMessage;
};

export const HandleError = (error: any, defaultErrorMessage?: string) => {
    return throwError(GetNetworkErrorMessage(error, defaultErrorMessage));
};

export const HandleAsyncError = async (error: any) => {
    return throwError(await GetAsyncNetworkErrorMessage(error));
};
